import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal } from 'antd';
import {
  useActiveWebsite,
  useWebsitesFacade,
  useWebsitesStoreLoading,
} from '../../store/hooks';
import { generateCodeSnippet } from '../../../shared';

type RouteParams = { id?: string };

const WebsitesCodeContainer: React.FC<RouteComponentProps<RouteParams>> = ({
  history,
  match,
}) => {
  const id = match.params.id;
  const facade = useWebsitesFacade();
  const activeWebsite = useActiveWebsite();
  const isLoading = useWebsitesStoreLoading();

  useEffect(() => {
    facade.setActiveWebsite(id!);

    facade.getWebsiteCode(id!);
  }, [facade, id]);

  const redirectToList = () => {
    history.replace('/admin/websites');

    facade.setActiveWebsite(null);
  };

  if (isLoading) {
    return null;
  }
  // TODO: Change path to depoloyed script
  const content = activeWebsite?.token ? (
    <>
      <p>{`Please, add following code to the top of the <head> tag and before any other script or CSS tags:`}</p>
      <pre className="code-snippet">
        <code>{generateCodeSnippet(activeWebsite.token).trim()}</code>
      </pre>
    </>
  ) : null;

  return (
    <Modal
      title={'Code snippet'}
      width={1060}
      destroyOnClose={true}
      visible={true}
      footer={null}
      onCancel={redirectToList}
    >
      {content}
    </Modal>
  );
};

export default WebsitesCodeContainer;
